
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi et comment créer une carte de visite efficace pour taxi",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez pourquoi une carte de visite est essentielle pour un taxi et suivez nos conseils pour créer une carte professionnelle qui attire et fidélise vos clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Pourquoi et comment créer votre carte de visite de taxi ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous explique pourquoi créer votre carte de visite de taxi. Il vous donne aussi des conseils et astuces pour une réalisation réussie.",
        },
      ],
    };
  },
};
